// src/redux/slice/evl/evl0111m_slice.ts

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import type {
  IEvl0111mState,
  ProjectEvaluationRow,
  IProjectQueryState,
} from "../../models/evl/evl0111m_model";

const initialState: IEvl0111mState = {
  rows: [],
  loading: false,

  posClsMap: {},

  // 입력값
  searchText: "",
  keyField: "all",
  statusFilter: "all",

  // 커밋값
  query: {
    keyField: "all",
    searchText: "",
    statusFilter: "all",
  },
};

export const evl0111m_Slice = createSlice({
  name: "evl0111m_Slice",
  initialState,
  reducers: {
    initState: () => initialState,

    setRows: (state, action: PayloadAction<ProjectEvaluationRow[]>) => {
      state.rows = action.payload ?? [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setPosClsMap: (state, action: PayloadAction<Record<string, string>>) => {
      state.posClsMap = action.payload ?? {};
    },

    // 입력값
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload ?? "";
    },
    setKeyField: (state, action: PayloadAction<string>) => {
      state.keyField = action.payload ?? "pjNm";
    },
    setStatusFilter: (state, action: PayloadAction<string>) => {
      state.statusFilter = action.payload ?? "all";
    },

    // query 커밋(버튼 눌렀을 때만)
    setQuery: (state, action: PayloadAction<IProjectQueryState>) => {
      state.query = action.payload;
    },

    // 초기화
    resetSearch: (state) => {
      state.keyField = "all";
      state.searchText = "";
      state.statusFilter = "all";
      state.query = { keyField: "pjNm", searchText: "", statusFilter: "all" };
    },
  },
});

export default evl0111m_Slice.reducer;
export const Evl0111mAction = evl0111m_Slice.actions;
export const Evl0111mReducer = evl0111m_Slice.reducer;
